import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enCommon from './locales/en/common.json'

export const defaultNS = 'common'
export const resources = {
  en: { common: enCommon },
} as const

i18n.use(initReactI18next)

void i18n.init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en'],
  defaultNS,
  ns: ['common'],
  interpolation: { escapeValue: false },
  initAsync: false,
  react: { useSuspense: false },
})

export default i18n
